import { CheckedAddress } from '@sparkdotfi/common-universal'

import { assets } from '@/ui/assets'

export const spkGovernanceSnapshotSpaceName = 'sparkfi.eth'

export const predefinedDelegates = [
  {
    address: CheckedAddress('0x71faa03c0cebcbb53236763b6b118ad906d9f6d3'),
    name: 'NeoNode',
    avatar: assets.governance.neoNodeAvatar,
  },
  {
    address: CheckedAddress('0xdc5d4228a42880f5bbd577a184035503bd55799a'),
    name: 'Remi',
    avatar: assets.governance.remiAvatar,
  },
  {
    address: CheckedAddress('0xF80A26ee68Bdf0224c18F85876b20858ee5206A9'),
    name: 'TheMoon',
    avatar: assets.governance.theMoonAvatar,
  },
]
